/**
 * SOCIAL_TYPE
 * @readonly
 * @description social 功能用(按讚、複製..etc) 的枚舉物件
 */
export const SOCIAL_TYPE = {
  JOURNAL: 1,
  TRIP: 2,
  MEMBER: 3,
  COLLECTION: 4,
  ARTICLE: 5,
  PRODUCT: 8,
  CAR_RENTAL: 9,
  HOTEL: 12,
  CITY: 13,
  PGC: 14,
  SIM: 15,
  AGENT: 16
};
